import { useFetchContext } from './UseFetchContext'
import { useNavigate } from 'react-router'
import { CLEAR_AGENT, SET_AGENT_SELECTED } from '../lib/typeKey'
import { IAgent } from '../lib/interface/agent'

const useHandleChangeAgent = () => {
  const { dispatch } = useFetchContext()
  const navigate = useNavigate()

  return (value: IAgent | null | undefined) => {
    if (value) {
      dispatch({ type: SET_AGENT_SELECTED, payload: value })
      navigate(`/${value.identifiantsAgent.idep.toLowerCase()}`)
    } else {
      dispatch({ type: CLEAR_AGENT })
      navigate(`/`)
    }
  }
}

export default useHandleChangeAgent
